function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.3334 11.6667V7.83333C18.3334 6.72876 17.4379 5.83333 16.3334 5.83333H13.3334M18.3334 11.6667V15.5C18.3334 16.6046 17.4379 17.5 16.3334 17.5H3.66669C2.56212 17.5 1.66669 16.6046 1.66669 15.5V11.6667M18.3334 11.6667H13.3334M1.66669 11.6667V7.83333C1.66669 6.72877 2.56212 5.83333 3.66669 5.83333H6.66669M1.66669 11.6667H6.66669M6.66669 11.6667V10M6.66669 11.6667V13.3333M6.66669 11.6667H13.3334M13.3334 11.6667V10M13.3334 11.6667V13.3333M13.3334 5.83333V4.5C13.3334 3.39543 12.4379 2.5 11.3334 2.5H8.66669C7.56212 2.5 6.66669 3.39543 6.66669 4.5V5.83333M13.3334 5.83333H6.66669",
  stroke: "#000126",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgIcBrandsDark = function SvgIcBrandsDark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcBrandsDark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-brands-dark.79bae42d.svg";
export { ForwardRef as ReactComponent };